// External packages
import * as React from 'react';
import { z } from 'zod';
import { useParams } from 'react-router-dom';

// Components
import { Button } from 'components/Button';
import { Icon } from 'components/Icons';
import { Card } from 'components/Card';

// Modules
import { ExhibitsModal } from 'modules/exhibits/ExhibitsModal';
import { ExhibitsList } from 'modules/exhibits/ExhibitsList';

// Hooks
import { useCreateExhibit } from 'api/exhibit';

// Schemas
import { exhibitsCreateSchema } from 'schemas/exhibit';

export default function ExhibitsPage() {
  const [modalOpen, setModalOpen] = React.useState(false);

  const { mutate: createExhibitMutation, isPending: isCreatingExhibit } =
    useCreateExhibit();

  const handleAddExhibit = (data: z.infer<typeof exhibitsCreateSchema>) => {
    createExhibitMutation(
      { data },
      {
        onSuccess: () => setModalOpen(false),
      }
    );
  };

  const { id: selectedExhibitId } = useParams();

  return (
    <Card className="flex flex-col h-full min-h-[calc(100vh-9rem)] md:min-h-[calc(100vh-8rem)]">
      <div className="flex items-center justify-between gap-x-8 gap-y-4">
        <h1 className="text-2xl text-gray-600">Eksponati</h1>
        <ExhibitsModal
          modalTrigger={
            <Button icon={<Icon name="plus" />}>Dodaj eksponat</Button>
          }
          onSubmit={handleAddExhibit}
          isOpen={modalOpen}
          onOpenChange={setModalOpen}
          isPending={isCreatingExhibit}
        />
      </div>
      <hr className="my-6 h-px text-gray-200" />
      <ExhibitsList selectedExhibitId={selectedExhibitId} />
    </Card>
  );
}
